var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container is-fluid",attrs:{"id":"viewport"}},[(_vm.isAuthenticated)?_c('Navbar'):_vm._e(),_c('router-view')],1),_c('Loader',{attrs:{"id":"global-loader","loading":_vm.loaderState,"fullscreen":true}}),_c('Patterns')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }